<template>
  <div class="glass-card">
    <nav class="flex px-2 py-2" aria-label="Tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        @click="$emit('change-tab', tab.key)"
        :class="[
          'ml-2 group inline-flex items-center px-4 py-2 border-t border-l border-r rounded-t-md text-sm font-medium  dark:text-white dark:bg-gray-700 transition-colors duration-150 ease-in-out',
          activeTab === tab.key
            ? 'bg-white text-blue-600 border-gray-300 -mb-px'
            : 'bg-gray-100 text-gray-500 border-transparent hover:bg-gray-50 hover:text-blue-600'
        ]"
      >
        <component
          :is="tab.icon"
          :class="[
            'mr-2 h-5 w-5',
            activeTab === tab.key ? 'text-blue-500' : 'text-gray-400 group-hover:text-blue-500'
          ]"
          aria-hidden="true"
        />
        <span>{{ tab.label }}</span>
      </button>
    </nav>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { Cog6ToothIcon, BoltIcon, ChartBarIcon, ServerIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  activeTab: {
    type: String,
    required: true,
  },
});

const tabs = reactive([
  { key: "siteDetails", label: "Site Details", icon: Cog6ToothIcon },
  { key: "snmp", label: "SNMP Configurations", icon: ServerIcon },
  { key: "tunnels", label: "Tunnels", icon: BoltIcon },
]);
</script>